module.exports = __webpack_public_path__ + "static/media/Elise.5dc7ec04.png";